import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { useLanguage } from "../context/LanguageContext";
import Hero from "../components/Hero";
import About from "../components/About";
import Specialties from "../components/Specialties";
import Pathologies from "../components/Pathologies";
import RAACProtocol from "../components/RAACProtocol";
import RecoveryCalculator from "../components/RecoveryCalculator";
import SportsTraumatology from "../components/SportsTraumatology";
import Locations from "../components/Locations";
import PlateauTechnique from "../components/PlateauTechnique";
import JudicialExpertise from "../components/JudicialExpertise";
import MediaConferences from "../components/MediaConferences";
import FAQSection from "../components/FAQSection";
import Testimonials from "../components/Testimonials";
import BlogPreview from "../components/BlogPreview";
import Gallery from "../components/Gallery";
import ContactSection from "../components/ContactSection";
import { translations } from "../i18n/translations";

const HomePage = () => {
  const location = useLocation();
  const { lang } = useLanguage();
  const isFr = lang === "fr";

  // Smooth scroll to anchor on mount or hash change
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          const y = el.getBoundingClientRect().top + window.scrollY - 72;
          window.scrollTo({ top: y, behavior: "smooth" });
        }, 100);
      }
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [location]);

  const title = isFr
    ? "Chirurgien Épaule, Coude & Main à Marseille — Dr Richard Aswad | IMOTEpS"
    : "Shoulder, Elbow & Hand Surgeon in Marseille — Dr Richard Aswad | IMOTEpS";
  const description = isFr
    ? "Dr Richard Aswad — chirurgien orthopédique du membre supérieur à Marseille (13008). Épaule du sportif, coiffe des rotateurs, prothèse, arthroscopie, microchirurgie, traumatologie du sport. Clinique Juge."
    : "Dr Richard Aswad — upper-limb orthopedic surgeon in Marseille (13008). Sports shoulder, rotator cuff, prosthesis, arthroscopy, microsurgery, sports trauma. Clinique Juge.";

  // FAQPage JSON-LD — eligible for Google rich snippets
  const faqItems = translations[lang]?.faq?.items || [];
  const faqJsonLd = faqItems.length > 0 ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  } : null;

  return (
    <>
      <SEOHead
        title={title}
        description={description}
        canonical="/"
        keywords="chirurgien épaule Marseille, chirurgie de l'épaule Marseille, chirurgien orthopédique Marseille, épaule du sportif Marseille, coiffe des rotateurs Marseille, prothèse épaule Marseille, arthroscopie épaule, canal carpien Marseille, tennis-elbow Marseille, Dr Aswad, IMOTEpS, Clinique Juge 13008"
        lang={lang}
        jsonLd={faqJsonLd}
      />
      <main data-testid="home-page">
      <Hero />
      <About />
      <Specialties />
      <Pathologies />
      <RAACProtocol />
      <RecoveryCalculator />
      <SportsTraumatology />
      <Locations />
      <PlateauTechnique />
      <JudicialExpertise />
      <MediaConferences />
      <Gallery />
      <Testimonials />
      <BlogPreview />
      <FAQSection />
      <ContactSection />
    </main>
    </>
  );
};

export default HomePage;
